import React, { useEffect, useState } from 'react';
import './EventsPageTable.css'
import { supabase } from '../../supabase';

import Edit from '../../Assets/Icons/Edit.svg'
import Delete from '../../Assets/Icons/Delete.svg'

const EventsPageTable = () => {
    const [events, setEvents] = useState([]);

    useEffect(()=>{
        const getEvents = async () => {
            const res = await supabase.from('Events').select('*')
            setEvents(res.data)
        }

        getEvents();
    } , [])

    const deleteEvent = async (id) => {
        const res = await supabase.from('Events').delete().eq('id', id)
        console.log(res);
    }

    return ( 
        <div className='EventsPageTable'>
            <p className='TableName'>All Events</p>

            <table>
                <tr className='TopRow'>
                    <th>
                        Event Name
                    </th>
                    <th>
                        Date
                    </th>
                    <th>
                        Location
                    </th>
                    <th>
                        Tickets Sold
                    </th>
                    <th>
                        Status
                    </th>
                    <th>
                        Actions
                    </th>
                </tr>
                {
                    events.map((item)=>{
                        return <tr>
                            <td>
                                {item.event_Name}
                            </td>
                            <td>
                                {item.event_Date}
                            </td>
                            <td>
                                {item.event_Loc}
                            </td>
                            <td>
                                {item.tickets_Sold + "/2000"}
                            </td>
                            <td>
                                <p className={item.status}>
                                    {item.status}
                                </p>
                            </td>
                            <td className='Actions'>
                                <img className='Edit' src={Edit} alt="" />
                                <img onClick={() => deleteEvent(item.id)} className='Delete' src={Delete} alt="" />
                            </td>
                        </tr>
                    })
                }
            </table>
        </div>
     );
}
 
export default EventsPageTable;